import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  userId: string;
  email: string;
  givenName: string;
  familyName: string;
  groups: string[];
}

interface AuthState {
  user: User | null;
  accessToken: string | null;
  idToken: string | null;
  isAuthenticated: boolean;
  isSuperAdmin: boolean;
  isAdmin: boolean;
  isMember: boolean;
  isPending: boolean;
  setAuth: (user: User, accessToken: string, idToken: string) => void;
  updateUser: (updates: Partial<User>) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      idToken: null,
      isAuthenticated: false,
      isSuperAdmin: false,
      isAdmin: false,
      isMember: false,
      isPending: false,
      setAuth: (user, accessToken, idToken) => {
        set({
          user,
          accessToken,
          idToken,
          isAuthenticated: true,
          isSuperAdmin: user.groups.includes('super-admin'),
          isAdmin: user.groups.includes('admin') || user.groups.includes('super-admin'),
          isMember: user.groups.includes('member') || user.groups.includes('super-admin'),
          isPending: user.groups.includes('pending'),
        });
      },
      updateUser: (updates) => {
        set((state) => {
          if (!state.user) return state;
          const updatedUser = { ...state.user, ...updates };
          return {
            ...state,
            user: updatedUser,
          };
        });
      },
      clearAuth: () =>
        set({
          user: null,
          accessToken: null,
          idToken: null,
          isAuthenticated: false,
          isSuperAdmin: false,
          isAdmin: false,
          isMember: false,
          isPending: false,
        }),
    }),
    {
      name: 'family-album-auth',
      // Store all state, not just partial - this ensures computed fields persist
    }
  )
);

